import { useCallback } from "react";

import { chatSessionLoadingTextVar } from "@apps/ask-ai/ask-ai-context";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherChatLoadingText({
  channelName,
}: {
  channelName: string;
}) {
  const handleChatSessionLoadingText = useCallback(
    ({ chat_session_id, text }: { chat_session_id: number; text: string }) => {
      chatSessionLoadingTextVar({ chatSessionId: chat_session_id, text });
    },
    [],
  );
  usePusher(
    channelName,
    "chat_session_loading_text",
    handleChatSessionLoadingText,
  );
  return null;
}
